import { React, useState, useContext, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../services/auth.service';
import { Eye, EyeSlash } from 'react-bootstrap-icons';
import { CompanyLogo } from '../../components/companyLogo';
import { Alert, Input, Checkbox, Spin } from 'antd';
import { Button } from 'antd';
import ReCAPTCHA from 'react-google-recaptcha';
import '../../styles/auth.scss';
import { useLocation} from 'react-router-dom';
import { InputModal } from '../../components/elements/InputModal';
import FetchService from '../../services/fetch.service';
// import { res } from 'react-email-validator';
import localStorageService from '../../services/localStorage.service';
export const LoginPage = () => {
    const { login, googleLogin, isLoggedIn,  setLocalStorageAfterLogin} = useContext(AuthContext);
    const navigate = useNavigate();
    const recaptchaRef = useRef(null);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loginResult, setLoginResult] = useState(true);
    const [showPassword, setShowPassword] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [captchaToken, setCaptchaToken] = useState("");
    const [UserEmail, setUserEmail] = useState("");
    const [InputModalOpen, setInputModalOpen] = useState(false);
    const [InputCode, setInputCode] = useState(null);
    const [RememberMe, setRememberMe] = useState(false);
    const [alertVisible, setAlertVisible] = useState(false);
    const [LoginResponseData, setLoginResponseData] = useState(null);
    const [LoginButtonEnabled, setLoginButtonEnabled] = useState(true);
    const [googleError, setGoogleError] = useState("");
    const [processingGoogleAuth, setProcessingGoogleAuth] = useState(false);
    const [googleOAuthConfig, setGoogleOAuthConfig] = useState(null);
    const handleInputChange = (event) => {
        const { name, value } = event.target;

        switch (name) {
            case "username":
                setUsername(value);
                break;
            case "password":
                setPassword(value);
                break;
            default:
        }
    };

    const handleRecaptchaChange = (token) => {

        setCaptchaToken(token);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!captchaToken) {
            alert("Please complete the reCAPTCHA.");
            return;
        }
        setLoginButtonEnabled(false);
        const response = await login({
            username,
            password,
            captchaToken,
        });
        if (response?.result?.result) {
            setLoginResponseData(response);
            setLoginResult(true);
            sendOtc(response)
        } else {
            // Reset reCAPTCHA if login fails
            recaptchaRef.current?.reset();
            setCaptchaToken("");
            setLoginButtonEnabled(true);
            setLoginResult(false);
        }
    };
    const sendOtc = async (LoginData) => {
        try {
            const response = LoginData ? LoginData : LoginResponseData
            
            // Extract user_info from the response
            const user_info = response?.result?.user_data;
            
            if (response?.email){
                if (!response?.TwoFactorEnabled){
                    setLocalStorageAfterLogin(response?.result)
                    navigate("/");
                    return;
                }
                setInputModalOpen(true);
                setUserEmail(response?.email);
                
                const fetchService = new FetchService();
                const responseApi = await fetchService("/login/send_otc", {
                    method: 'POST',
                    cache: 'no-cache',
                    mode: 'cors',
                    body: JSON.stringify({email: response?.email}),
                    headers: {
                        'Accept': 'application/json',
                        "Content-Type": 'application/json',
                    },
                    credentials: 'include',
                });
                const respData = await responseApi.json();
                if (!respData?.result) {
                    console.error("Failed to send OTC:", respData);
                    setGoogleError("Failed to send OTC code. Please try again.");
                    setProcessingGoogleAuth(false);
                    setLoginButtonEnabled(true);
                }
            } else {
                console.error("no email found in response");
                setGoogleError("Invalid login response. Please try again.");
                setProcessingGoogleAuth(false);
                setLoginButtonEnabled(true);
            }
        } catch (error) {
            console.error("Error in sendOtc:", error);
            setGoogleError("An error occurred during login. Please try again.");
            setProcessingGoogleAuth(false);
            setLoginButtonEnabled(true);
        }
    };
    useEffect(() => {
        // Check for success message flag
        const wasPasswordJustSet = localStorage.getItem('passwordSetupSuccess');
        if (wasPasswordJustSet === 'true') {
            setShowSuccessMessage(true);
            // Remove the flag after showing the message
            localStorage.removeItem('passwordSetupSuccess');
        }
    }, []);

    const handleDismissSuccessMessage = () => {
        setShowSuccessMessage(false);
    };
    const closeInputModal = () => {
        setInputModalOpen(false)
        setLoginButtonEnabled(true);
    }
    const modalInputChangeFn = (e) => {
        setInputCode(e.target.value);
    }
    const checkVerification = async () => {
        const fetchService = new FetchService();
        const responseApi = await fetchService("/login/verify_otc", {
            method: 'POST',
            cache: 'no-cache',
            mode: 'cors',
            body: JSON.stringify({email: UserEmail, code: InputCode, remember_me: RememberMe}),
            headers: {
                'Accept': 'application/json',
                "Content-Type": 'application/json',
            },
            credentials: 'include',
        });
        const results = await responseApi.json()
        if (results?.result) {
            setLocalStorageAfterLogin()
            navigate("/");
        } else {
            setAlertVisible(true)
        }
    }
    
    // Fetch Google OAuth configuration on component mount
    useEffect(() => {
        const fetchGoogleOAuthConfig = async () => {
            try {
                const fetchService = new FetchService();
                const response = await fetchService("/get_google_oauth_config/", {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                });
                const data = await response.json();
                if (data?.result) {
                    setGoogleOAuthConfig(data.data);
                } else {
                    console.error("Failed to fetch Google OAuth config:", data.error);
                }
            } catch (error) {
                console.error("Error fetching Google OAuth config:", error);
            }
        };
        
        fetchGoogleOAuthConfig();
    }, []);
    
    const handleGoogleSignIn = () => {
        // Check if config is loaded
        if (!googleOAuthConfig) {
            console.error("Google OAuth config not loaded yet");
            return;
        }
        
        // OAuth client for user login (separate from GTM API client in client_secret.json)
        // This client is configured with redirect URI: /profiles/auth/callback/
        const clientId = googleOAuthConfig.client_id;
        
        // Make redirect URI dynamic based on environment
        const currentHost = window.location.origin;
        const redirectUri = currentHost.includes('localhost') 
            ? googleOAuthConfig.redirect_uri_dev
            : googleOAuthConfig.redirect_uri_prod;
        
        // Include GTM scopes so user doesn't need to re-authorize for bulk edit
        const scope = 'openid email profile https://www.googleapis.com/auth/tagmanager.edit.containers';
        
        const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?` +
            `client_id=${clientId}&` +
            `redirect_uri=${encodeURIComponent(redirectUri)}&` +
            `response_type=code&` +
            `scope=${encodeURIComponent(scope)}&` +
            `access_type=offline&` +
            `prompt=select_account&` +
            `include_granted_scopes=true`;
        window.location.href = authUrl;
    };

    // Handle Google OAuth callback
    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
        const tempToken = query.get('temp_token');
        const error = query.get('error');
        
        // Handle OAuth errors
        if (error) {
            console.error('Google OAuth error:', error);
            
            // Provide user-friendly error messages
            let errorMessage;
            if (error === 'account_not_found') {
                errorMessage = 'No account found with this Google account. Please contact support if you do have a account.';
            } else if (error === 'account_not_activated') {
                errorMessage = 'Your account has not been activated yet. Please check your email for the activation link and follow the instructions to activate your account before signing in.';
            } else if (error === 'account_setup_incomplete') {
                errorMessage = 'Your account setup is not complete yet. Please complete your account setup by clicking the setup link sent to your email before signing in.';
            } else {
                errorMessage = `There was a problem signing in with Google. Please try again or contact support if the issue persists.`;
            }
            
            setGoogleError(errorMessage);
            setLoginResult(true); // Don't show regular login error
            // Clear the error from URL
            window.history.replaceState({}, document.title, window.location.pathname);
            return;
        }
        
        if (tempToken) {
            // Set processing state to disable form and show loading
            setProcessingGoogleAuth(true);
            setLoginButtonEnabled(false);
            
            const handleGoogleAuthCallback = async () => {
                try {
                    const response = await googleLogin(tempToken);
                    
                    // Remove query parameters from URL first
                    window.history.replaceState({}, document.title, window.location.pathname);
                    
                    if (response?.result) {
 
                        // Use the same flow as regular login - call sendOtc to handle 2FA
                        setLoginResponseData(response);
                        setLoginResult(true);
                        
                        // Immediately check 2FA and redirect or show modal
                        await sendOtc(response);
                    } else {
                        console.error('Google login failed:', response.error);
                        setGoogleError('Google login failed: ' + (response.error || 'Unknown error'));
                        setLoginResult(true); // Don't show regular login error
                        setLoginButtonEnabled(true);
                        setProcessingGoogleAuth(false);
                    }
                } catch (error) {
                    console.error('Error during Google login:', error);
                    setGoogleError('Login failed due to network error. Please try again.');
                    setLoginResult(true); // Don't show regular login error
                    setLoginButtonEnabled(true);
                    setProcessingGoogleAuth(false);
                    // Remove query parameters from URL
                    window.history.replaceState({}, document.title, window.location.pathname);
                }
            };
            
            handleGoogleAuthCallback();
        }
    }, [googleLogin, navigate]);    return (
        <div className='auth-container login-page'>
            <div className="bottom-circle"></div>
            <div className="auth-form-container">
                <div className="text-center mb-2">
                    <CompanyLogo />
                </div>
                
                {processingGoogleAuth && !googleError && !InputModalOpen ? (
                    // Show only loading spinner when processing Google auth (hide login form)
                    <div className="text-center" style={{ padding: '60px 0' }}>
                        <Spin size="large" />
                        <h2 className='auth-heading text-center mt-4'>Signing you in...</h2>
                        <p style={{ color: '#666', marginTop: '16px' }}>
                            Please wait while we complete your authentication
                        </p>
                    </div>
                ) : (
                    <>
                        {!showSuccessMessage && (
                            <h1 className='auth-heading text-center'>Login</h1>
                        )}
                        
                        {showSuccessMessage && (
                            <div className="success-container">
                                <div className="success-title">
                                    Your account has been successfully created!
                                </div>
                                <div className="success-description">
                                    Please log in to access the portal
                                </div>
                            </div>
                        )}
                
                        {!loginResult && (
                            <Alert
                                message="Login Failed"
                                description="Please enter a correct username and password. Note that both fields may be case-sensitive."
                                type="error"
                                showIcon
                                className="auth-alert"
                            />
                        )}
                        
                        {googleError && (
                            <Alert
                                message="Login error"
                                description={googleError}
                                type="error"
                                showIcon
                                closable
                                onClose={() => setGoogleError("")}
                                className="auth-alert"
                            />
                        )}
                
                        <form method="POST" className="mt-4" onSubmit={handleSubmit}>
                    
                    <div className="mt-4">
                        <button type="button" onClick={handleGoogleSignIn} className="auth-button google-signin-button" disabled={processingGoogleAuth}>
                            <svg className="google-icon" width="18" height="18" viewBox="0 0 24 24">
                                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                            </svg>
                            Sign in with Google
                        </button>
                    </div>

                    <div className="auth-divider">
                        <span className="divider-text">OR</span>
                    </div>

                    <div className="mb-3">
                        <input
                            type="text"
                            autoFocus
                            autoCapitalize="none"
                            autoComplete="username"
                            maxLength="150"
                            className="auth-input"
                            required
                            id="id_auth-username"
                            placeholder="Email address"
                            name="username"
                            value={username}
                            onChange={handleInputChange}
                            disabled={processingGoogleAuth}
                        />
                    </div>
                    <div className="password-field-container">
                        <input
                            autoComplete="current-password"
                            className="auth-input"
                            required
                            id="id_auth-password"
                            placeholder="Password"
                            name="password"
                            value={password}
                            onChange={handleInputChange}
                            type={showPassword ? "text" : "password"}
                            disabled={processingGoogleAuth}
                        />
                        <label className='eye-slash-icon' htmlFor="check">
                            {showPassword ? (
                                <Eye />
                            ) : (
                                <EyeSlash />
                            )}
                        </label>
                        <input
                            id="check"
                            type="checkbox"
                            value={showPassword}
                            onChange={() => setShowPassword((prev) => !prev)}
                            style={{ display: 'none' }}
                        />
                    </div>

                    <div className="mt-3">
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey="6Ldi_i4rAAAAAFCkkEM4jMWTrnKbVZ4OggTzxKiV" // Replace with your reCAPTCHA site key
                            onChange={handleRecaptchaChange}
                        />
                    </div>
        
                    <div className="mt-4">
                        <button type="submit" className="auth-button" disabled={!LoginButtonEnabled || processingGoogleAuth}>
                            Log in
                        </button>
                    </div>
                    
                    <div className="mt-4">
                        <a className="auth-secondary-button d-block text-center" href="/password-reset">Forgot Password?</a>
                    </div>
                </form>
                </>
                )}
                
                <InputModal 
                    visible={InputModalOpen} 
                    alertVisible={alertVisible}
                    onConfirm={checkVerification} 
                    email={UserEmail} 
                    modalInputChange={modalInputChangeFn}
                    sendOtc={sendOtc}
                    setRememberMe={setRememberMe}
                />

            </div>
        </div>
    );
};